<template>
  <div class="turnOverTeam">
    <el-dialog
      class="customDialog"
      top="15vh"
      title="移交团队"
      width="460px"
      :visible.sync="isShow"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="close"
    >
      <div class="tip">每个团队只有一个创建者，移交后你将变为管理者</div>
      <div v-if="memberTableData.length !== 0" class="listContainer">
        <div
          :class="['item', selectItem === index ? 'active' : '']"
          v-for="(item, index) of memberTableData"
          :key="item.userId"
          @click="trunOver(item, index)"
        >
          <div class="name">
            <img
              :src="
                item.profilePhoto
                  ? item.profilePhoto
                  : require('@/assets/images/head_fill.png')
              "
            /><span>{{ item.userName }}</span>
          </div>
          <img :src="selectItem === index ? selected : select" />
        </div>
      </div>
      <div v-else class="listContainer noPeople">
        <img src="~@/assets/images/no-people.png" />
        <span>当前没有其他成员</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button
          :disabled="memberTableData.length === 0"
          type="primary"
          @click="submitTurn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { userList, handoverTeam } from '@/api/teamManagement'
export default {
  name: 'turnOverTeam',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    teamId: {
      type: Number,
      default: null
    }
  },
  computed: {
    isShow: {
      get: function (v) {
        return this.show
      },
      set: function (v) {
        // 点击关闭按钮更新父组件传过来的参数为false
        this.$emit('update:show', v)
      }
    }
  },
  data () {
    return {
      selected: require('@/assets/images/team-selected.png'),
      select: require('@/assets/images/team-select.png'),
      memberTableData: [],
      selectItem: -1,
      params: {
        id: '',
        memberId: ''
      }
    }
  },
  mounted () {
    this.initShowMembers()
  },
  methods: {
    initShowMembers () {
      const params = {
        flag: false,
        teamId: this.teamId,
        keyword: ''
      }
      userList(params).then((res) => {
        if (res.code === 200) {
          this.memberTableData = res.data
        }
      })
    },

    trunOver (item, index) {
      this.selectItem = index
      this.params.id = item.teamId
      this.params.memberId = item.userId
    },
    submitTurn () {
      const _this = this
      this.$Delete({
        confirm: () => {
          handoverTeam(_this.params).then((res) => {
            if (res.code === 200) {
              this.$emit('showMembers')
              this.isShow = false
              _this.$Message('success', '移交成功')
            }
          })
        },
        message: '是否确认移交团队?'
      })
    },
    close () {
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.turnOverTeam {
  .tip {
    color: #fff;
    margin-bottom: 15px;
  }
  .listContainer {
    width: 420px;
    height: 270px;
    background: #303133;
    border-radius: 6px;
    padding: 15px 16px;
    overflow: auto;
    .active {
      background: rgba($color: #fff, $alpha: 0.1);
    }
    > .item:hover {
      background: rgba($color: #fff, $alpha: 0.1);
    }
    .item {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      border-radius: 6px;
      cursor: pointer;
      .name {
        color: #fff;
        display: flex;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 11px;
        }
      }
    }
  }
  .noPeople {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 75px;
  }
}
</style>
